const UKFlagIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={className}
  >
    <defs>
      <clipPath id="uk-flag-round">
        <rect width="24" height="24" fill="#fff" rx="12" />
      </clipPath>
      <clipPath id="uk-flag-inner">
        <rect width="32" height="24" x="-4" fill="#fff" rx="3.429" />
      </clipPath>
    </defs>
    <g clipPath="url(#uk-flag-round)">
      <rect width="24" height="24" fill="#fff" rx="12" />
      <g clipPath="url(#uk-flag-inner)">
        <rect width="32" height="24" x="-4" fill="#fff" rx="3.429" />
        <path
          fill="#2E42A5"
          fillRule="evenodd"
          d="M-4 0v24h32V0z"
          clipRule="evenodd"
        />
        <mask
          id="uk-flag-mask"
          width="32"
          height="24"
          x="-4"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M-4 0v24h32V0z"
            clipRule="evenodd"
          />
        </mask>
        <g mask="url(#uk-flag-mask)">
          <path
            fill="#fff"
            d="m-7.562 22.286 7.041 2.978L28.16 3.238l3.715-4.425-7.53-.996L12.646 7.31 3.23 13.704z"
          />
          <path
            fill="#F50100"
            d="m-6.602 24.372 3.588 1.729L30.538-1.6H25.5z"
          />
          <path
            fill="#fff"
            d="m31.563 22.286-7.042 2.978L-4.16 3.238l-3.715-4.425 7.53-.996L11.354 7.31l9.416 6.395z"
          />
          <path
            fill="#F50100"
            d="m31.32 23.784-3.587 1.728-14.287-11.86-4.236-1.325L-8.234-1.172h5.037l17.435 13.179 4.63 1.589z"
          />
          <mask id="uk-flag-cross-mask" fill="#fff">
            <path d="M15.773 8h14.25v8h-14.25v10H8.218V16H-5.977V8H8.218V-2h7.555z" />
          </mask>
          <path
            fill="#F50100"
            d="M15.773 8h14.25v8h-14.25v10H8.218V16H-5.977V8H8.218V-2h7.555z"
          />
          <path
            fill="#fff"
            d="M15.773 8h-2v2h2zm14.25 0h2V6h-2zm0 8v2h2v-2zm-14.25 0v-2h-2v2zm0 10v2h2v-2zm-7.555 0h-2v2h2zm0-10h2v-2h-2zm-14.195 0h-2v2h2zm0-8V6h-2v2zM8.218 8v2h2V8zm0-10v-2h-2v2zm7.555 0h2v-2h-2zm0 10v2h14.25V6h-14.25zm14.25 0h-2v8h4V8zm0 8v-2h-14.25v4h14.25zm-14.25 0h-2v10h4V16zm0 10v-2H8.218v4h7.555zm-7.555 0h2V16h-4v10zm0-10v-2H-5.977v4H8.218zm-14.195 0h2V8h-4v8zm0-8v2H8.218V6H-5.977zM8.218 8h2V-2h-4V8zm0-10v2h7.555v-4H8.218zm7.555 0h-2V8h4V-2z"
            mask="url(#uk-flag-cross-mask)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default UKFlagIcon;
